/**
 * @Author:      jiang.weiwei
 * @DateTime:    2017-12-12 17:19:48
 * @Description: 新建用户
 */
"use strict";
angular.module("importUserModule", []).
controller("importUserCtrl", ["$scope", "$validation", "modalDialog", "$modalInstance", "httpService", "$q", "$timeout", "userInformationService", function($scope, $validation, modalDialog, $modalInstance, httpService, $q, $timeout, userInformationService) {
	initStatus();
	initData();

	function initStatus() {
		$scope.data = {
			picList: []
		};
		$scope.status = {
			file: null
		};
	}

	function initData() {
		initInput();
	}
	function initInput() {
		$scope.status.file = $(document.createElement("input"));
		$scope.status.file.attr({
			type: "file",
			name: "file",
			class: "webuploader-element-invisible",
			accept: ".xlsx"
		});
		$scope.status.file[0].onchange = function () {
			var self = this;
			$timeout(function () {
				for (var i = 0; i < self.files.length; i++) {
					if (self.files[i].name.split(".")[1] == "xlsx") {
						$scope.data.picList = [self.files[i]];
					} else {
						modalDialog.alertType("请上传符合格式要求的文件", "", "error", false);
					}
				}
				$timeout(function () {
				});
				initInput();
			});
		};
	};
	/**
	 * [chooseLocalPics 上传本地图片]
	 * @return {[type]} [description]
	 */
	$scope.chooseLocalPics = function () {
		$scope.status.file[0].click();
	};
	$scope.cancel = function() {
		$modalInstance.dismiss();
	};
	$scope.confirm = function() {
		if (!$scope.data.picList.length) {
			modalDialog.alertType("请先上传文件！", "", "error", false);
			return;
		}
		$scope.loadingPromise = uploadFile();
	};

	function uploadFile() {
		const defer = $q.defer();
		const formData = new FormData();
		$scope.data.picList.forEach(function (file) {
			formData.append("file", file);
		});
		var xhr = new XMLHttpRequest();
		xhr.open('POST', '/mcnadmin/admin/ugcuser/importUsers.do', true);
		xhr.onload = function (evt) {
			const response = JSON.parse(evt.target.responseText);
			if (response.data.errorCount === 0) {
				modalDialog.alertType("导入成功", "", "success", false);
				$modalInstance.close();
			} else {
				userInformationService.importResult(response.data);
				if (response.data.successCount > 0) {
					$modalInstance.close();
				} else {
					$scope.cancel();
				}
			}
			defer.resolve();
		};
		xhr.send(formData);
		return defer.promise;
	}
}]);